// Custom 4-point star rating visual (1-5)
export default function StarRating({ score = 0, stars = 0, size = "md", testid = "star-rating" }) {
    const total = 5;
    const sizes = { sm: "w-3.5 h-3.5", md: "w-5 h-5", lg: "w-7 h-7" };
    const cls = sizes[size] || sizes.md;
    return (
        <div className="flex items-center gap-2" data-testid={testid}>
            <div className="flex items-center gap-1">
                {Array.from({ length: total }).map((_, i) => (
                    <svg
                        key={`star-${i}`}
                        viewBox="0 0 24 24"
                        className={`${cls} ${i < stars ? "text-planet-sun" : "text-ink/15"}`}
                        fill="currentColor"
                        aria-hidden
                    >
                        <path d="M12 1.5 L13.6 9 L21 12 L13.6 15 L12 22.5 L10.4 15 L3 12 L10.4 9 Z" />
                    </svg>
                ))}
            </div>
            {score !== null && score !== undefined && (
                <span className="font-serif text-2xl text-ink" data-testid={`${testid}-score`}>{score}</span>
            )}
        </div>
    );
}
